import { Autocomplete, TextField } from '@mui/material'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { IRootState } from '../../../../redux/types'

interface ILine {
  id: number
  name: string
}

function LineAutocomplete({ value, brand, handleInputChange }: any) {
  const { t } = useTranslation(['global'])

  const { errorForm, msgForm } = useSelector((state: IRootState) => state.validator)

  const handleAutoCompleteChange = (line: ILine | null) => {
    handleInputChange('line', line)
  }

  const belongsLinetoBrand = (): boolean => {
    return brand?.active_lines?.some((line: ILine) => line.name === value?.name)
  }

  useEffect(() => {
    if (!belongsLinetoBrand()) handleInputChange('line', null)
  }, [brand])

  return (
    <Autocomplete
      id="autocomplete-lines"
      value={value}
      ChipProps={{ color: 'secondary' }}
      onChange={(_, value) => handleAutoCompleteChange(value)}
      options={brand?.active_lines ?? []}
      getOptionLabel={(option: any) => (option.id !== undefined ? option.name : '')}
      renderInput={params => (
        <TextField
          {...params}
          label={t('line')}
          variant="filled"
          InputLabelProps={{ shrink: true }}
          error={errorForm.lines}
          helperText={msgForm.lines}
        />
      )}
    />
  )
}

export default LineAutocomplete
